"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = getNestedValue;
function getNestedValue(o, path) {
    let value = o;
    for (const key of path) {
        if (typeof value === "undefined") {
            return undefined;
        }
        value = value[key];
    }
    return value;
}
//# sourceMappingURL=getNestedValue.js.map